<template>
    <div class="user-profile">
        <form @submit.prevent="validateForm">
            <div class="form-row">
                <div class="form-group col-md-2 required">
                    <label>Designation</label>
                    <select name="designation" data-vv-validate-on="blur" data-vv-as="designation"
                        v-model="value.designationChoice" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('designation')
                    }">
                        <option v-for="(designation, index) in designations" :key="index"
                            :value="designation.value">
                            {{designation.text}}
                        </option>
                    </select>
                    <div v-show="validationErrors.has('designation')" class="invalid-feedback">
                        {{ validationErrors.first('designation') }}
                    </div>

                    <input v-if="value.designationChoice === -1" type="text" name="designationText" data-vv-validate-on="blur" data-vv-as="designation"
                        placeholder="Designation" v-model="value.designation" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('designationText')
                    }">
                    <div v-show="validationErrors.has('designationText')" class="invalid-feedback">
                        {{ validationErrors.first('designationText') }}
                    </div>
                </div>
                <div class="form-group col-md-7 required">
                    <label>Full Name</label>
                    <input type="text" name="fullName" data-vv-validate-on="blur" data-vv-as="full name" placeholder="Full Name"
                        v-model="value.name" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('fullName')
                    }">
                    <div v-show="validationErrors.has('fullName')" class="invalid-feedback">
                        {{ validationErrors.first('fullName') }}
                    </div>
                </div>
                <div class="form-group col-md-3 required">
                    <label>Gender</label>
                    <select name="gender" data-vv-validate-on="blur" v-model="value.gender" v-validate="genderValidation"
                        :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('gender')
                    }">
                        <option value="0">Please Select</option>
                        <option v-for="(gender, index) in genders" :key="index" :value="gender.value">
                            {{gender.text}}
                        </option>
                    </select>
                    <div v-show="validationErrors.has('gender')" class="invalid-feedback">
                        {{ validationErrors.first('gender') }}
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-lg-4 col-md-6 required">
                    <label>Identification Type</label>
                    <select name="identificationType" data-vv-validate-on="blur" data-vv-as="identification type"
                        v-validate="identificationTypeValidation" v-model="value.identitifcationType" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('identificationType')
                    }">
                        <option value="0">Please Select</option>
                        <option v-for="(identificationType, index) in identificationTypes" :key="index" :value="identificationType.value">
                            {{identificationType.text}}
                        </option>
                    </select>
                    <div v-show="validationErrors.has('identificationType')" class="invalid-feedback">
                        {{ validationErrors.first('identificationType') }}
                    </div>
                </div>

                <div class="form-group col-lg-4 col-md-6 required">
                    <label>Identification Number</label>
                    <input type="text" name="identityNumber" data-vv-validate-on="blur"
                        data-vv-as="identification number" v-mask="value.identitifcationType === 1 ? '######-##-####' : null" placeholder="Identification Number"
                        v-model="value.identificationNumber" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('identityNumber')
                    }">
                    <div v-show="validationErrors.has('identityNumber')" class="invalid-feedback">
                        {{ validationErrors.first('identityNumber') }}
                    </div>
                </div>

                <div class="form-group col-lg-4 col-md-12 required">
                    <label>Birth Date</label>
                    <input type="text" name="birthDate" data-vv-as="birth date" data-vv-validate-on="blur"
                        v-model="value.birthDate"
                        v-mask="'##/##/####'"
                        v-validate="'required|date_format:DD/MM/YYYY'" placeholder="DD/MM/YYYY"
                        :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('birthDate')
                    }" />
                    <div v-show="validationErrors.has('birthDate')" class="invalid-feedback">
                        {{ validationErrors.first('birthDate') }}
                    </div>
                </div>
            </div>

        <div class="form-row">
            <div class="form-group col-md-6 required">
                <label>Email Address</label>
                <input type="text"
                    class="form-control"
                    v-model="value.email"
                    disabled>
            </div>

            <div class="form-group col-md-6 required">
                <label>Phone Number</label>
                <input type="text"
                    name="phoneNumber"
                    data-vv-validate-on="blur"
                    data-vv-as="phone number"
                    placeholder="Phone Number"
                    v-model="value.phoneNo"
                    v-validate="'required'"
                    :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('phoneNumber')
                    }">
                <div v-show="validationErrors.has('phoneNumber')"
                    class="invalid-feedback">
                    {{ validationErrors.first('phoneNumber') }}
                </div>
            </div>
        </div>
        </form>
    </div>
</template>

<script>
import { getBirthDateFromNewIc } from '@/utilities';
import profileMixins from './profileMixins';
// import { mask } from 'vue-the-mask';
import {
    Validator
} from 'vee-validate';
import identificationTypes from '@/config/identificationTypes';
import genders from '@/config/genders';
import designations from '@/config/designations';
import { VueMaskDirective } from 'v-mask';
export default {
    'name': 'UserProfileComponent',
    'props': {
        'value': Object
    },
    'mixins': [
        profileMixins
    ],
    'directives': {
        // mask,
        'mask': VueMaskDirective
    },
    'computed': {
        genderValidation () {
            let minGenderValue = this.genders[0].value;
            let maxGenderValue = this.genders[this.genders.length - 1].value;

            return `required|between:${minGenderValue},${maxGenderValue}`;
        },
        identificationTypeValidation () {
            let minIdentificationType = this.identificationTypes[0].value;
            let maxIdentificationType = this.identificationTypes[this.identificationTypes.length - 1].value;

            return `required|between:${minIdentificationType},${maxIdentificationType}`;
        },
        profileIcNumber () {
            if (this.value && this.value.identificationNumber) {
                return this.value.identificationNumber;
            }
            return null;
        }
    },
    'watch': {
        profileIcNumber (icNumber) {
            if (icNumber && this.value && this.value.identitifcationType) {
                if (this.value.identitifcationType === 1) {
                    let birthDate = getBirthDateFromNewIc(icNumber);

                    if (birthDate) {
                        this.value.birthDate = birthDate;
                    }
                }
            }
        }
    },
    data () {
        return {
            identificationTypes,
            genders,
            designations
        };
    },
    mounted () {
        const dict = {
            'custom': {
                'gender': {
                    'between': 'Gender is required.'
                },
                'identificationType': {
                    'between': 'Identification type is required.'
                }
            }
        };
        Validator.localize('en', dict);
        this.$validator.localize('en', dict);
    }
};

</script>
